import { ApiResponse } from "src/vzbl-api-handler";

export async function post<
  Route extends (...args: any[]) => any,
  Body extends {} = {}
>(url: string, body?: Body, { signal }: Partial<{ signal: AbortSignal }> = {}) {
  console.log(`🔍 [HTTP] Making POST request to: ${url}`);
  console.log(`🔍 [HTTP] Request body type:`, typeof body);
  console.log(`🔍 [HTTP] Request body content:`, body);
  console.log(
    `🔍 [HTTP] Request body JSON:`,
    JSON.stringify(body || {}, null, 2)
  );

  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body || {}),
    signal,
  })
    .then((resp) => {
      console.log(
        `🔍 [HTTP] Response status: ${resp.status} ${resp.statusText}`
      );
      console.log(
        `🔍 [HTTP] Response headers:`,
        Object.fromEntries(resp.headers.entries())
      );

      if (!resp.ok) {
        console.error(
          `❌ [HTTP] Non-OK response: ${resp.status} ${resp.statusText}`
        );
        throw new Error(`HTTP ${resp.status}: ${resp.statusText}`);
      }

      return resp.json();
    })
    .then((json) => {
      console.log(`🔍 [HTTP] Parsed JSON response:`, {
        jsonType: typeof json,
        isNull: json === null,
        isUndefined: json === undefined,
        hasError: json?.error,
        hasData: json?.data,
        keys: json && typeof json === "object" ? Object.keys(json) : "N/A",
      });

      // Log the actual JSON content for debugging
      console.log(`🔍 [HTTP] Full JSON response content:`, json);

      if (json?.error) {
        console.error(`❌ [HTTP] API returned error: ${json.error}`);
        console.error(`❌ [HTTP] Full error response:`, json);
        throw new Error(`${json.error}`);
      }

      if (json?.name === "ZodError") {
        console.error(`❌ [HTTP] ZodError:`, json.data?.issues);
        console.error(`❌ [HTTP] Full ZodError response:`, json);
        throw new Error(JSON.stringify(json.data?.issues, null, 3));
      }

      return json;
    })
    .then((payload: ApiResponse<Route>) => {
      console.log(`🔍 [HTTP] Final payload:`, {
        payloadType: typeof payload,
        isNull: payload === null,
        isUndefined: payload === undefined,
        keys:
          payload && typeof payload === "object" ? Object.keys(payload) : "N/A",
      });

      return payload;
    })
    .catch((error) => {
      console.error(`❌ [HTTP] Error in POST request to ${url}:`, error);
      console.error(`❌ [HTTP] Error details:`, {
        message: error instanceof Error ? error.message : String(error),
        stack: error instanceof Error ? error.stack : "No stack trace",
        url: url,
        body: body,
      });
      throw error;
    });
}

export function orgPoster<
  RequestBody extends {} = {},
  ResponseType extends (...args: any[]) => any = () => any
>(path = "") {
  return (orgId: string, body?: RequestBody) =>
    post<ResponseType>(`/api/${orgId}//${path}`, body);
}
